import React from 'react';
import PropTypes from 'prop-types';
import { MainMenu } from 'components';
import strings from '../../utils/translationStrings';

import './Footer.scss';

export const Footer = (props) => {
  Footer.propTypes = {
    lang: PropTypes.string.isRequired
  };

  const { lang } = props;

  return (
    <section id="footer">
      <div className="footer-menu">
        <MainMenu
          items={[
            {
              title: strings.footerCopyrights.footer_returnPolicy,
              to: `/${lang}/return-policy`
            },
            {
              title: strings.footerCopyrights.footer_termsOfService,
              to: `/${lang}/terms`
            },
            {
              title: strings.footerCopyrights.footer_privacyPolicy,
              to: `/${lang}/privacy-policy`
            },
            {
              title: strings.footerCopyrights.footer_cookiesPolicy,
              to: `/${lang}/cookies-policy`
            },
            {
              title: strings.footerCopyrights.footer_aboutUs,
              to: `/${lang}/about-us`
            },
            {
              title: 'FAQ',
              to: `/${lang}/faq`
            },
          ]}
        />
      </div>
      <span className="divider" />
      <div className="copyright">
        © {(new Date()).getFullYear()} {strings.footerCopyrights.footer_rights}
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js